"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThread = exports.ThreadProvider = void 0;
const react_1 = require("react");
const ThreadContext = (0, react_1.createContext)(undefined);
ThreadContext.displayName = "ThreadContext";
const ThreadProvider = ThreadContext.Provider;
exports.ThreadProvider = ThreadProvider;
// N.B. The context won't update from undefined until on the client-side
// so we add a check here to only throw an error if the Provider isn't supplied
// properly if we're on client-side, and to return default values if we're server-side
const useThread = () => {
    const context = (0, react_1.useContext)(ThreadContext);
    if (typeof window !== "undefined") {
        if (context === undefined) {
            throw new Error("This component is a ThreadConsumer, it must be used within a ThreadProvider");
        }
        return context;
    }
    return (context !== null && context !== void 0 ? context : {
        trackedMessageRefs: { current: {} },
        scrollAnchorRef: { current: null },
    });
};
exports.useThread = useThread;
//# sourceMappingURL=ThreadContext.js.map